import Phaser from "phaser";
import { bootTargetScene, resolveEntry } from "../flow/entry";
import { assertTransition, SceneKey } from "../flow/game-flow";
import { markActiveScene, markAssetsReady } from "../ui/screen-state";

export class BootScene extends Phaser.Scene {
  constructor() {
    super(SceneKey.Boot);
  }

  create(): void {
    markActiveScene(SceneKey.Boot);
    markAssetsReady(true);
    const target = bootTargetScene(resolveEntry());
    assertTransition(SceneKey.Boot, target);
    this.scene.start(target);
  }
}
